// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

export const Col = styled.div.withConfig({ displayName: "styles__Col", componentId: "sc-1o1ispa-0" })(["height:100%;display:flex;align-items:center;justify-content:center;width:100%;position:relative;"]);








export const LeftCol = styled.div.withConfig({ displayName: "styles__LeftCol", componentId: "sc-1o1ispa-1" })(["border-right:1px solid #c0ccd7;height:100%;display:flex;justify-content:flex-end;padding-right:6px;align-items:center;width:60px;box-sizing:border-box;font-size:10px;"]);











export const EmptyCol = styled(LeftCol).withConfig({ displayName: "styles__EmptyCol", componentId: "sc-1o1ispa-2" })(["border:none;"]);



export const Row = styled.div.withConfig({ displayName: "styles__Row", componentId: "sc-1o1ispa-3" })(["height:21px;display:flex;& ", "{border-right:1px solid #c0ccd7;&:last-child{border-right:none;}}"],


Col);







export const Footer = styled.footer.withConfig({ displayName: "styles__Footer", componentId: "sc-1o1ispa-4" })(["height:21px;display:flex;"]);




export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-1o1ispa-5" })(["border:1px solid #c0ccd7;margin-top:22px;& ", "{border-bottom:1px solid #c0ccd7;&:last-child{border-bottom:none;}}"],


Row);







export const Delimiter = styled.div.withConfig({ displayName: "styles__Delimiter", componentId: "sc-1o1ispa-6" })(["height:100%;width:1px;position:absolute;z-index:-1;transform:translateX(-50%);background:#c0ccd7;"]);








export const Layer = styled.div.withConfig({ displayName: "styles__Layer", componentId: "sc-1o1ispa-7" })(["display:flex;align-items:center;position:absolute;left:0;right:0;bottom:0;top:0;"]);









export const FooterTimes = styled.div.withConfig({ displayName: "styles__FooterTimes", componentId: "sc-1o1ispa-8" })(["display:flex;height:100%;width:100%;font-size:10px;align-items:center;justify-content:space-between;"]);








export const PlayerArea = styled.div.withConfig({ displayName: "styles__PlayerArea", componentId: "sc-1o1ispa-9" })(["cursor:pointer;position:relative;width:100%;height:100%;"]);






export const PlayerTick = styled(({ x, ...props }) => <div {...props} />).withConfig({ displayName: "styles__PlayerTick", componentId: "sc-1o1ispa-10" })(["height:42px;position:absolute;z-index:2;", ";top:0;width:2px;background:#3d4042;&::before{content:'';display:block;position:absolute;border-radius:50%;width:10px;height:10px;top:-10px;left:-4px;border:2px solid #3d4042;}"],



(props) => css(["left:", "px;"],
props.x));

















export const CurrentTick = styled(({ x, ...props }) => <p {...props} />).withConfig({ displayName: "styles__CurrentTick", componentId: "sc-1o1ispa-11" })(["position:absolute;background:white;z-index:2;", ";"],



(props) =>
props.x &&
css(["left:", "px;"],
props.x + 60));



export const PlayedTrack = styled(({ width, ...props }) => <div {...props} />).withConfig({ displayName: "styles__PlayedTrack", componentId: "sc-1o1ispa-12" })(["background:#c0ccd7;height:5px;position:absolute;left:0;", ";"],




(props) =>
props.width &&
css(["width:", "px;"],
props.width));
